import $ from 'jquery';
import ko from '@tko/build.knockout';
import 'bootstrap-multiselect/dist/js/bootstrap-multiselect';

ko.bindingHandlers.multiselect2 = {
  after: ['options', 'value', 'selectedOptions'],

  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var $el = $(element);
    var config = ko.unwrap(valueAccessor()) || {};

    // Initialize Bootstrap Multiselect
    $el.multiselect(config);

    if (allBindings.has('options')) {
      var options = allBindings.get('options');
      if (ko.isObservable(options)) {
        ko.computed({
          read: function() {
            options();
            setTimeout(function() {
              var ms = $el.data('multiselect');
              if (ms)
                ms.updateOriginalOptions(); //Not sure how beneficial this is.
              $el.multiselect('rebuild');
            }, 1);
          },
          disposeWhenNodeIsRemoved: element
        });
      }
    }


    // Update Knockout's selectedOptions when the widget changes
    $el.on('change.multiselect2', function () {
      var selected = $el.val() || [];
      var allBindingsAccessor = allBindings();

      
      if (ko.isObservable(allBindingsAccessor.value)) {
        allBindingsAccessor.value(selected);
      } else if (ko.isObservable(allBindingsAccessor.selectedOptions)) {
        allBindingsAccessor.selectedOptions(selected);
      }
      

      var config = ko.unwrap(allBindingsAccessor.options);

      $el.multiselect('setOptions', config);
      $el.multiselect('rebuild');
      // this also updates the options

    });

    // Ensure memory cleanup if Knockout removes the element
    ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
      $el.multiselect('destroy');
    });
  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var $el = $(element);
    var config = ko.toJS(valueAccessor());
    var allBindingsAccessor = allBindings();

    // Unwrap selectedOptions to establish the dependency for the update trigger
    if (allBindingsAccessor.value) {
      ko.unwrap(allBindingsAccessor.value);
    } else if (allBindingsAccessor.selectedOptions) {
      ko.unwrap(allBindingsAccessor.selectedOptions);
    }
    
    $el.multiselect('setOptions', config);
    $el.multiselect('rebuild');
  }
};
